/* eslint-disable */
import React from 'react'
import {Link} from 'react-router-dom'
import http from '../../Component/Interceptor/Interseptor'
import {message} from 'antd'
import {Button, Container, Modal, ModalBody, ModalFooter, ModalHeader} from 'mdbreact'
import Page from '../../Component/Pagination/Pagination'
import HeaderTable from '../BaseComponent/HeaderTable'
import $ from 'jquery'
import cookie from 'react-cookies'
import jMoment from 'moment-jalaali'
import USER_MANAGE from '../BaseComponent/USERMANAGE'
import USER_REPORT from '../BaseComponent/USERREPORT'
import HeaderTablePrint from '../BaseComponent/HeaderTablePrint'
import ExcelExport from '@progress/kendo-react-excel-export/dist/npm/ExcelExport'
import Sort from '../Pagination/Sort'
import HeaderGrid from '../Pagination/HeaderGrid'
import Pageing from '../Pagination/pageing'
import Loader from '../loaders/loader'

class Drivers extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      drivers: [],
      printInfo: [],
      DriversCount: 0,
      modalActivate: false,
      modalBlock: false,
      modalReset: false,
      modalChangeCar: false,
      cars: [],
      modalDelete: false,
      pageNumber: 1,
      pageSize: 10,
      sortBy: '',
      sortData: [
        {
          name: 'شناسه',
          value: 'personId',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'نام',
          value: 'firstName',
          sorted: false,
          direction: null,
          sortable: true
        },
        {
          name: 'موبایل',
          value: 'mobile',
          sorted: false,
          direction: null,
          sortable: true
        },
        {
          name: 'نام کاربری',
          value: 'userName',
          sorted: false,
          direction: null,
          sortable: true
        },
        {
          name: 'ترتیب نمایش',
          value: 'userName',
          sorted: false,
          direction: null,
          sortable: true
        },
        {
          name: 'ویرایش',
          value: 'edit',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'ریست رمز عبور',
          value: 'edit',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'وضعیت فعال',
          value: 'edit',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'وضعیت بلاک',
          value: 'edit',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'ثبت سهمیه بنزین',
          value: 'edit',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'حذف',
          value: 'edit',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'اتومبیل',
          value: 'edit',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'ویرایش اتومبیل',
          value: 'edit',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'سرجمع پرداختی',
          value: 'edit',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'فاکتورها',
          value: 'edit',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'آخرین مسیر',
          value: 'edit',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'تاریخچه مسیرها',
          value: 'edit',
          sorted: false,
          direction: null,
          sortable: false
        }
      ]
    }
  }

  createFilter = (exportStatus) => {
    let filter = {}
    filter.pageNumber = this.state.pageNumber
    filter.pageSize = this.state.pageSize
    filter.sortBy = this.state.sortBy
    filter.export = exportStatus
    let active = $('#active').val()
    let oilSupport = $('#oilSupport').val()
    let block = $('#block').val()
    let firstname = $('#firstname')
      .val()
      .trim()
    let lastname = $('#lastname')
      .val()
      .trim()
    let username = $('#username')
      .val()
      .trim()
    let mobile = this.convertDigit(
      $('#mobile')
        .val()
        .trim()
    )
    let phone = this.convertDigit(
      $('#phone')
        .val()
        .trim()
    )
    let gender = $('#gender').val()
    let nationalId = this.convertDigit(
      $('#nationalId')
        .val()
        .trim()
    )
    let email = $('#email').val()
    let father = $('#father')
      .val()
      .trim()
    let address = $('#address')
      .val()
      .trim()
    let zipCode = this.convertDigit(
      $('#zipCode')
        .val()
        .trim()
    )
    if (active !== '') {
      filter.active = active
    }
    if (oilSupport !== '') {
      filter.oilSupport = oilSupport
    }
    if (block !== '') {
      filter.block = block
    }
    if (firstname !== '') {
      filter.firstname = firstname
    }
    if (lastname !== '') {
      filter.lastname = lastname
    }
    if (username !== '') {
      filter.username = username
    }
    if (mobile !== '') {
      filter.mobile = mobile
    }
    if (phone !== '') {
      filter.phone = phone
    }
    if (gender !== '') {
      filter.gender = gender
    }
    if (nationalId !== '') {
      filter.nationalId = nationalId
    }
    if (email !== '') {
      filter.email = email
    }
    if (father !== '') {
      filter.father = father
    }
    if (address !== '') {
      filter.address = address
    }
    if (zipCode !== '') {
      filter.zipCode = zipCode
    }
    return filter
  }
  getReport = (exportStatus) => {
    let filter = this.createFilter(exportStatus)
    this.setState({
      loading: true
    })
    http
      .get(`${USER_REPORT.USER_REPORT_DRIVER}`, {
        params: filter
      })
      .then((response) => {
        if (response.data.error == null) {
          if (!exportStatus) {
            this.setState({
              drivers: response.data.object.result,
              countAll: response.data.object.countAll,
              loading: false
            })
          } else {
            this.setState({
              printInfo: response.data.object.result,
              loading: false
            })
          }
        } else {
          this.setState({
            loading: false
          })
        }
      })
      .catch(() => {
        this.setState({
          loading: false
        })
      })
  }
  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevState.pageNumber !== this.state.pageNumber) {
      this.getReport(false)
    }
    if (prevState.pageSize !== this.state.pageSize) {
      this.setState(
        {
          pageNumber: 1
        },
        () => {
          this.getReport(false)
        }
      )
    }
    if (prevState.sortBy !== this.state.sortBy) {
      this.getReport(false)
    }
  }
  componentDidMount() {
    $(function() {
      $('.filterBtn').on('click', function() {
        $('.filterComponent').slideToggle()
      })

      $('.cancelFilter').click(function() {
        $('.filterComponent').slideUp()
      })
    })
    this.getReport(false)

    http
      .get(`car/manage/list`, {})
      .then((response) => {
        if (response.data.error == null) {
          this.setState({
            cars: response.data.object
          })
        }
      })
      .catch((error) => {
        console.log(error)
      })
  }

  openActivate = (personId, fullName, isActive) => {
    this.setState({
      modalActivate: !this.state.modalActivate,
      personId,
      isActive,
      fullName
    })
  }

  ConfirmActivate() {
    let {personId, isActive} = this.state
    if (isActive) {
      let reason = '1'
      let data = {
        personId,
        reasonId: reason
      }
      http
        .post(`${USER_MANAGE.USER_MANAGE_DEACTIVATE}`, data, {})
        .then((response) => {
          if (response.data.error === null) {
            message.success('عملیات تغییر وضعیت کاربر با موفقیت انجام شد')
            this.getReport(false)
            this.setState({
              modalActivate: !this.state.modalActivate
            })
          }
        })
        .catch((error) => {
          alert(JSON.stringify(error))
        })
    } else {
      let reason = '1'
      let data = {
        personId,
        reasonId: reason
      }

      http
        .post(`${USER_MANAGE.USER_MANAGE_ACTIVATE}`, data, {})
        .then((response) => {
          if (response.data.error === null) {
            this.setState({
              modalActivate: !this.state.modalActivate
            })
            message.success('عملیات تغییر وضعیت کاربر با موفقیت انجام شد')
            this.getReport(false)
          } else {
            this.setState({
              modalActivate: !this.state.modalActivate
            })
          }
        })
        .catch((error) => {
          alert(JSON.stringify(error))
        })
    }
  }

  openBlock = (personId, fullName, isBlock) => {
    this.setState({
      modalBlock: !this.state.modalBlock,
      personId,
      isBlock,
      fullName
    })
  }

  ConfirmBlock() {
    let {personId, isBlock} = this.state
    if (isBlock) {
      let reason = '1'
      let data = {
        personId,
        reasonId: reason
      }

      http
        .post(`${USER_MANAGE.USER_MANAGE_UNBLOCK}`, data, {})
        .then((response) => {
          if (response.data.error === null) {
            this.setState({
              modalBlock: !this.state.modalBlock
            })
            message.success('عملیات تغییر وضعیت بلاک کاربر با موفقیت انجام شد')
            this.getReport(false)
          } else {
            this.setState({
              modalActivate: !this.state.modalActivate
            })
          }
        })
        .catch(() => {})
    } else {
      let reason = '1'
      let data = {
        personId,
        reasonId: reason
      }

      http
        .post(`${USER_MANAGE.USER_MANAGE_BLOCK}`, data, {})
        .then((response) => {
          if (response.data.error === null) {
            this.setState({
              modalBlock: !this.state.modalBlock
            })
            this.getReport(false)
            message.success('عملیات تغییر وضعیت بلاک کاربر با موفقیت انجام شد')
          } else {
            this.setState({
              modalActivate: !this.state.modalActivate
            })
          }
        })
        .catch(() => {})
    }
  }

  openChangeCar = (personId, fullName) => {
    this.setState({
      modalChangeCar: !this.state.modalChangeCar,
      personId,
      fullName
    })
  }

  confirmChangeCar = () => {
    let {personId} = this.state
    let carId = document.getElementById('carId').value
    if (carId == '') {
      message.error('خودرو  را وارد کنید')
    } else {
      let data = {
        driverId: personId,
        carId: Number(carId)
      }
      http.post(`${USER_MANAGE.USER_MANAGE_EDIT_DRIVER_CAR}`, data, {}).then((response) => {
        if (response.data.error === null) {
          this.getReport(false)
          message.success('تغییر خودروی کاربر موفقیت آمیز بود')
          this.setState({
            modalChangeCar: !this.state.modalChangeCar
          })
        } else {
          this.setState({
            modalChangeCar: !this.state.modalChangeCar
          })
        }
      })
    }
  }

  deleteDriver = (personId, fullName) => {
    this.setState({
      modalDelete: !this.state.modalDelete,
      personId,
      fullName
    })
  }

  deleteOk = () => {
    let reason = '1'
    let {personId} = this.state
    let data = {
      personId,
      reasonId: reason
    }
    http
      .post(`${USER_MANAGE.USER_MANAGE_DELETE}`, data, {})
      .then((response) => {
        if (response.data.error === null) {
          message.success('رساننده با موفقیت حذف شد')
          this.getReport(false)
          this.setState({
            modalDelete: !this.state.modalDelete
          })
        } else {
          this.setState({
            modalDelete: !this.state.modalDelete
          })
        }
      })
      .catch(() => {})
  }

  convertDigit = (string) => {
    return string
      .replace(/[\u0660-\u0669]/g, function(c) {
        return c.charCodeAt(0) - 0x0660
      })
      .replace(/[\u06f0-\u06f9]/g, function(c) {
        return c.charCodeAt(0) - 0x06f0
      })
  }

  filter() {
    this.setState(
      {
        pageNumber: 1
      },
      () => {
        this.getReport(false)
      }
    )
  }

  exportExcel = () => {
    let filter = this.createFilter(true)
    http
      .get(`${USER_REPORT.USER_REPORT_DRIVER}`, {
        params: filter
      })
      .then((response) => {
        if (response.data.error == null) {
          this.setState({
            excelReport: response.data.object.result
          })
          this._export.save(this.state.excelReport)
        } else {
          this.setState({
            excelReport: []
          })
        }
      })
      .catch((error) => {
        // alert(JSON.stringify(error))
      })
  }

  getPrintInfo = () => {
    this.getReport(true)
  }

  exportPrint = () => {
    var css = '@page { size:A4 portrait;}',
      head = document.head || document.getElementsByTagName('head')[0],
      style = document.createElement('style')

    style.type = 'text/css'
    style.media = 'print'

    if (style.styleSheet) {
      style.styleSheet.cssText = css
    } else {
      style.appendChild(document.createTextNode(css))
    }

    head.appendChild(style)
    this.getPrintInfo()
    setTimeout(() => {
      window.print()
    }, 2000)
  }

  editSortOrder = (editSortOrder, personId, fullName) => {
    this.setState({
      editSortOrder,
      personId,
      fullName,
      editSortOrderModal: true
    })
  }
  editSortOrderOk = () => {
    let {personId} = this.state
    let sortOrderVal = document.getElementById('sortOrder').value
    if (sortOrderVal === '') {
      message.error('ترتیب نمایش وارد شود')
    } else {
      let data = {
        sortOrder: Number(sortOrderVal),
        driverId: personId
      }
      http.post(`user/manage/edit/driver/sort-order`, data, {}).then((res) => {
        if (res.data.error === null) {
          message.success('با موفقیت انجام شد')
          this.getReport(false)
          this.setState({
            editSortOrderModal: false
          })
        }
      })
    }
  }

  openReset = (personId, fullName) => {
    this.setState({
      modalReset: !this.state.modalReset,
      personId,
      fullName
    })
  }

  confirmReset = () => {
    let password = document.getElementById('password').value
    if (password === '') {
      message.error('کلمه عبور جدید را وارد کنید')
    } else {
      let data = {
        personId: this.state.personId,
        password
      }

      http
        .post(`${USER_MANAGE.USER_MANAGE_EDIT_PASSWORD}`, data, {})
        .then((response) => {
          if (response.data.error === null) {
            message.success('تغییر کلمه عبور با موفقیت انجام شد')
            this.setState({
              modalReset: !this.state.modalReset
            })
          }
        })
        .catch((error) => {})
    }
  }

  openChangeStatusOil = (personId, fullName, oilSupport) => {
    this.setState({
      personId,
      fullName,
      oilSupport,
      modalOil: true
    })
  }

  changeStatusOilsupport = () => {
    let {personId, oilSupport} = this.state
    if (oilSupport) {
      let data = {
        driverId: personId
      }
      http
        .post(`${USER_MANAGE.USER_MANAGE_DRIVER_OIL_UNSUPPORT}`, data, {})
        .then((response) => {
          if (response.data.error === null) {
            message.success('با موفقیت انجام شد')
            this.getReport(false)
            this.setState({
              modalOil: !this.state.modalOil
            })
          }
        })
        .catch((error) => {
          alert(JSON.stringify(error))
        })
    } else {
      let data = {
        driverId: personId
      }
      http
        .post(`${USER_MANAGE.USER_MANAGE_DRIVER_OIL_SUPPORT}`, data, {})
        .then((response) => {
          if (response.data.error === null) {
            this.setState({
              modalOil: !this.state.modalOil
            })
            message.success('با موفقیت انجام شد')
            this.getReport(false)
          } else {
            this.setState({
              modalOil: !this.state.modalOil
            })
          }
        })
        .catch((error) => {
          alert(JSON.stringify(error))
        })
    }
  }

  getSort = (sortBy) => {
    this.setState({
      sortBy
    })
  }
  getPageSize = (pageSize) => {
    this.setState({
      pageSize
    })
  }

  getPageNumber = (pageNumber) => {
    this.setState({
      pageNumber
    })
  }

  render() {
    let {pageNumber, pageSize, loading} = this.state

    let printCol = ['ردیف', 'نام', 'موبایل', 'نام کاربری', 'شناسه', 'وضعیت فعال', 'وضعیت بلاک']
    return (
      <div className="rtl printA4Page">
        <Loader show={loading} />
        <div className="printSection">
          <table className="printTable printReportTable" ref={(node) => (this.printPart = node)}>
            <HeaderTablePrint
              header="لیست رساننده ها"
              headerColSpan={7}
              reporter={cookie.load('name')}
              timePrint={jMoment().format('jYYYY/jM/jD HH:mm')}
              leftColSpan={5}
              rightColSpan={1}
              centerColSpan={1}
              centerSection={''}
              rightSection={''}
              columns={printCol}
            />

            <tbody>
              {this.state.printInfo.map((drivers, index) => (
                <tr key={'i' + index}>
                  <td>{index + 1}</td>
                  <td>{drivers.firstname + ' ' + drivers.lastname}</td>
                  <td>{drivers.mobile}</td>
                  <td>{drivers.username}</td>
                  <td>{drivers.personId}</td>

                  <td>{drivers.active ? 'فعال' : 'غیر فعال'}</td>
                  <td>{drivers.block ? 'بلاک' : 'خارج از بلاک'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="excelSection">
          <ExcelExport
            dir="rtl"
            ref={(exporter) => {
              this._export = exporter
            }}
            fileName="لیست رساننده ها.xls"
          >
            <grid style={{height: '420px'}} data={this.state.excelReport}>
              <gridColumn
                key={'firstname'}
                field={'firstname'}
                title={'نام'}
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'lastname'}
                field={'lastname'}
                title={'نام خانوادگی'}
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'mobile'}
                field={'mobile'}
                title={'موبایل'}
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'username'}
                field={'username'}
                title={'نام کاربری'}
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'personId'}
                field={'personId'}
                title={'شناسه'}
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'car'}
                field={'car.code'}
                title={'اتومبیل'}
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
            </grid>
          </ExcelExport>
        </div>

        <div className="wrapperIframe">
          <ul className="breadcrumb">
            <li>
              <Link to={'/search'}>به روزرسان</Link>
            </li>
            <li>کاربران</li>
            <li>رساننده ها</li>
          </ul>
          <div className="tableComponent">
            <div className="tableTools">
              <div className="tableOptionWrapp">
                <HeaderGrid getPageSize={this.getPageSize} createLink={'/AddUser'} enablePageSize />
                <button className="filterBtn">
                  <i className="fa fa-search" />
                </button>
                <button className={'printButton'} onClick={this.exportExcel}>
                  <i className="fas fa-file-excel" />
                </button>
                <button className="printButton" onClick={this.exportPrint}>
                  <i className="fas fa-print" />
                </button>
              </div>
            </div>
            <div className="filterComponent">
              <div className="filterInputs">
                <div className="formComponent">
                  <label>نام</label>
                  <input className="form-control" id="firstname" type="text" />
                </div>
                <div className="formComponent">
                  <label>نام خانوادگی</label>
                  <input className="form-control" id="lastname" type="text" />
                </div>
                <div className="formComponent">
                  <label>نام کاربری</label>
                  <input className="form-control" id="username" type="text" />
                </div>
                <div className="formComponent">
                  <label>بلاک</label>
                  <select id="block" className="form-control">
                    <option value="">------</option>
                    <option value={0}>خارج از بلاک</option>
                    <option value={1}>بلاک</option>
                  </select>
                </div>
                <div className="formComponent">
                  <label>فعال</label>
                  <select id="active" className="form-control">
                    <option value="">------</option>

                    <option value={0}>غیر فعال</option>
                    <option value={1}>فعال</option>
                  </select>
                </div>
                <div className="formComponent">
                  <label>سهمیه بنزین</label>
                  <select id="oilSupport" className="form-control">
                    <option value="">------</option>

                    <option value={0}>ندارد</option>
                    <option value={1}>دارد</option>
                  </select>
                </div>

                <div className="formComponent">
                  <label>تلفن</label>
                  <input className="form-control" id="phone" type="text" />
                </div>

                <div className="formComponent">
                  <label>موبایل</label>
                  <input className="form-control" id="mobile" type="text" />
                </div>
                <div className="formComponent">
                  <label>کد ملی</label>
                  <input className="form-control" id="nationalId" type="text" />
                </div>
                <div className="formComponent">
                  <label>ایمیل</label>
                  <input className="form-control" id="email" type="email" />
                </div>
                <div className="formComponent">
                  <label>نام پدر</label>
                  <input className="form-control" id="father" type="text" />
                </div>
                <div className="formComponent">
                  <label>کد پستی</label>
                  <input className="form-control" id="zipCode" type="text" />
                </div>
                <div className="formComponent">
                  <label>آدرس</label>
                  <input className="form-control" id="address" type="text" />
                </div>
                <div className="formComponent">
                  <label>جنسیت</label>
                  <select id="gender" className="form-control">
                    <option value="">------</option>
                    <option value={'man'}>مرد</option>
                    <option value={'woman'}>زن</option>
                  </select>
                </div>
              </div>
              <div className="filterOption">
                <button className="confirmFilter" onClick={this.filter.bind(this)}>
                  جست و جو
                </button>
              </div>
            </div>

            <div className="showBaseTable">
              <table className="baseTable">
                <Sort data={this.state.sortData} getSort={this.getSort} />
                <tbody>
                  {this.state.drivers.map((drivers, index) => (
                    <tr key={index}>
                      <td>{drivers.personId}</td>
                      <td>{drivers.firstname + ' ' + drivers.lastname}</td>
                      <td>{drivers.mobile}</td>
                      <td>{drivers.username}</td>
                      <td>
                        <button
                          className="btn btn-sm text-dark"
                          onClick={() => this.editSortOrder(drivers.sortOrder, drivers.personId, drivers.fullName)}
                        >
                          <span className="font-weight-bold">
                            {drivers.sortOrder === null ? 'ثبت ترتیب نمایش' : drivers.sortOrder}
                          </span>
                        </button>
                      </td>

                      <td>
                        <Link to={`/editInfoUsers/${drivers.personId}`}>
                          <img src={require('../../image/editDriver.svg')} alt="" />
                        </Link>
                      </td>
                      <td>
                        <button onClick={() => this.openReset(drivers.personId, drivers.fullName)}>
                          <img src={require('../../image/reset.svg')} alt="" />
                        </button>
                      </td>
                      <td>
                        <button onClick={() => this.openActivate(drivers.personId, drivers.fullName, drivers.active)}>
                          {drivers.active ? (
                            <img src={require('../../image/on.svg')} alt="" />
                          ) : (
                            <img src={require('../../image/off.svg')} alt="" />
                          )}
                        </button>
                      </td>
                      <td>
                        <button onClick={() => this.openBlock(drivers.personId, drivers.fullName, drivers.block)}>
                          {drivers.block ? (
                            <img src={require('../../image/on.svg')} alt="" />
                          ) : (
                            <img src={require('../../image/off.svg')} alt="" />
                          )}
                        </button>
                      </td>
                      <td>
                        <button
                          onClick={() =>
                            this.openChangeStatusOil(drivers.personId, drivers.fullName, drivers.oilSupport)
                          }
                        >
                          {drivers.oilSupport ? (
                            <img src={require('../../image/on.svg')} alt="" />
                          ) : (
                            <img src={require('../../image/off.svg')} alt="" />
                          )}
                        </button>
                      </td>
                      <td>
                        <button onClick={() => this.deleteDriver(drivers.personId, drivers.fullName)}>
                          <img src={require('../../image/trash.svg')} alt="" />
                        </button>
                      </td>
                      <td>
                        <span>{drivers.car == null ? '-' : drivers.car.name}</span>
                        <br />
                        <span>
                          {drivers.car == null
                            ? '-'
                            : 'ایران ' +
                              drivers.car.plateNumber +
                              '-' +
                              drivers.car.plateText +
                              ' کد ' +
                              drivers.car.code}
                        </span>
                      </td>
                      <td>
                        <button onClick={() => this.openChangeCar(drivers.personId, drivers.fullName)}>
                          <img src={require('../../image/editDriver.svg')} alt="" />
                        </button>
                      </td>
                      <td>
                        <Link to={`/statisticalDriver/driverId=${drivers.personId}/driverName=${drivers.fullName}`}>
                          <img src={require('../../image/money.svg')} alt="" />
                        </Link>
                      </td>
                      <td>
                        <Link to={`/PlanDrivers/${drivers.personId}/${drivers.firstname + ' ' + drivers.lastname}`}>
                          <img src={require('../../image/bill.svg')} alt="" />
                        </Link>
                      </td>
                      <td>
                        <Link to={`livePosition/driver=${drivers.personId}`}>
                          <img src={require('../../image/liveRoute.svg')} alt="" />
                        </Link>
                      </td>
                      <td>
                        <Link to={`trajectory/${drivers.personId}/${drivers.firstname + ' ' + drivers.lastname}`}>
                          <img src={require('../../image/route.svg')} alt="" />
                        </Link>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <div className="paginationWrapp">
                <Pageing
                  defaultCurrent={1}
                  getPage={this.getPageNumber}
                  pageSize={this.state.pageSize}
                  currentPage={this.state.pageNumber}
                  total={this.state.countAll}
                />
              </div>
            </div>
          </div>
        </div>
        <Modal isOpen={this.state.modalActivate} toggle={() => this.setState({modalActivate: false})} size="sm">
          <ModalHeader toggle={() => this.setState({modalActivate: false})}>
            {this.state.isActive ? 'غیر فعالسازی کاربر' : 'فعالسازی کاربر'}
          </ModalHeader>
          <ModalBody>
            <p className="titleSm">
              {this.state.isActive ? 'علت غیر فعال سازی کاربر چیست' : 'علت فعال سازی کاربر چیست'}
            </p>
            <select className="form-control">
              <option value="1">اقدام ادمین</option>
            </select>
          </ModalBody>
          <ModalFooter>
            <button className="confirmBtnModal" onClick={this.ConfirmActivate.bind(this)}>
              اعمال
            </button>
            <button className="cancelBtnModal" onClick={() => this.setState({modalActivate: false})}>
              لغو
            </button>
          </ModalFooter>
        </Modal>
        <Modal isOpen={this.state.modalBlock} toggle={() => this.setState({modalBlock: false})} size="sm">
          <ModalHeader toggle={() => this.setState({modalBlock: false})}>
            {this.state.isBlock ? 'خروج از بلاک کاربر' : 'بلاک کردن کاربر'}
          </ModalHeader>
          <ModalBody>
            <p className="titleSm">{this.state.isBlock ? 'علت خروج از بلاک کاربر چیست؟' : 'علت  بلاک کاربر چیست؟'}</p>
            <select className="form-control">
              <option value="1">اقدام ادمین</option>
            </select>
          </ModalBody>
          <ModalFooter>
            <button className="confirmBtnModal" onClick={this.ConfirmBlock.bind(this)}>
              اعمال
            </button>
            <button className="cancelBtnModal" onClick={() => this.setState({modalBlock: false})}>
              لغو
            </button>
          </ModalFooter>
        </Modal>
        <Modal isOpen={this.state.modalReset} toggle={() => this.setState({modalReset: false})} size="sm">
          <ModalHeader toggle={this.toggleReset}>بازنشانی کلمه عبور کاربر</ModalHeader>
          <ModalBody>
            <div className="modalForm">
              <label htmlFor="password"> کلمه عبور جدید برای {this.state.fullName}</label>
              <input type="password" id="password" name="password" className="form-control" />
            </div>
          </ModalBody>
          <ModalFooter>
            <button className="confirmBtnModal" onClick={this.confirmReset.bind(this)}>
              بازنشانی
            </button>
            <button className="cancelBtnModal" onClick={() => this.setState({modalReset: false})}>
              لغو
            </button>
          </ModalFooter>
        </Modal>
        <Modal isOpen={this.state.modalChangeCar} toggle={() => this.setState({modalChangeCar: false})} size="sm">
          <ModalHeader toggle={() => this.setState({modalChangeCar: false})}>تغییر خودروی کاربر</ModalHeader>
          <ModalBody>
            <div className="modalForm">
              <label htmlFor="password"> تغییر خودرو برای {this.state.fullName}</label>
              <select className="form-control" id="carId" name="carId">
                <option value="">خودرو</option>
                {this.state.cars.map((cars, index) => (
                  <option value={cars.carId} key={'cars' + index}>
                    {cars.name + ' شماره ' + cars.code}
                  </option>
                ))}
              </select>
            </div>
          </ModalBody>
          <ModalFooter>
            <button className="confirmBtnModal" onClick={this.confirmChangeCar.bind(this)}>
              تغییر خودرو
            </button>
            <button className="cancelBtnModal" onClick={() => this.setState({modalChangeCar: false})}>
              لغو
            </button>
          </ModalFooter>
        </Modal>
        <Modal isOpen={this.state.modalDelete} toggle={() => this.setState({modalDelete: false})} size="sm">
          <ModalHeader toggle={() => this.setState({modalDelete: false})}>حذف رساننده</ModalHeader>
          <ModalBody>
            <p className="titleSm"> علت حذف {this.state.fullName} ؟؟؟</p>
            <select className="form-control">
              <option value="1">اقدام ادمین</option>
            </select>
          </ModalBody>
          <ModalFooter>
            <button className="confirmBtnModal" onClick={this.deleteOk}>
              حذف رساننده
            </button>
            <button className="cancelBtnModal" onClick={() => this.setState({modalDelete: false})}>
              لغو
            </button>
          </ModalFooter>
        </Modal>
        <Modal isOpen={this.state.editSortOrderModal} toggle={(e) => this.closeEditSort(e)} size="sm">
          <ModalHeader toggle={this.deleteCancel}>ترتیب نمایش رساننده</ModalHeader>
          <ModalBody>
            <p className="titleSm"> ترتیب نمایش برای {this.state.fullName} </p>
            <input type="number" className="form-control" defaultValue={this.state.editSortOrder} id="sortOrder" />
          </ModalBody>
          <ModalFooter>
            <button className="confirmBtnModal" onClick={this.editSortOrderOk}>
              ویرایش
            </button>
            <button className="cancelBtnModal" onClick={() => this.setState({editSortOrderModal: false})}>
              لغو
            </button>
          </ModalFooter>
        </Modal>
        <Modal isOpen={this.state.modalOil} toggle={() => this.setState({modalOil: false})} size="sm">
          <ModalHeader toggle={() => this.setState({modalOil: false})}>
            {this.state.oilSupport ? 'عدم تخصیص سهمیه بنزین' : 'تخصیص سهمیه بنزین'}
          </ModalHeader>
          <ModalBody>
            <p className="mb-0 text-center">
              {this.state.oilSupport
                ? `آیا از عدم تخصیص سهمیه بنزین به ${this.state.fullName} اطمینان دارید ؟`
                : `آیا از تخصیص سهمیه بنزین به ${this.state.fullName} اطمینان دارید ؟`}
            </p>
          </ModalBody>
          <ModalFooter>
            <button className="confirmBtnModal" onClick={this.changeStatusOilsupport}>
              اعمال
            </button>
            <button className="cancelBtnModal" onClick={() => this.setState({modalOil: false})}>
              لغو
            </button>
          </ModalFooter>
        </Modal>
      </div>
    )
  }
}

export default Drivers
